import { render, staticRenderFns } from "./ActionButtonGroup.vue?vue&type=template&id=530b4221&scoped=true"
import script from "./ActionButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ActionButtonGroup.vue?vue&type=script&lang=ts"
import style0 from "./ActionButtonGroup.vue?vue&type=style&index=0&id=530b4221&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b4221",
  null
  
)

export default component.exports